<template lang="html">
  <div v-if="selectedModel">
    <div style="margin-bottom: 35px;">
        {{ $tr(`vacancy.voiceBot.dialect.settings.${model.name}.title`) }}
    </div>

  <vue-slider
    class="custom-slider"
    ref="slider"
    v-model="value"
    :data="options"
    :lazy="true"
    @callback="callback"
  ></vue-slider>

  </div>
</template>

<style>
    .custom-slider {
        margin-top: 10px;
        font-size: 16.1px;
    }

    .custom-slider.vue-slider-wrap .vue-slider {
        border-radius: 0 !important;
        height: 29px !important;
    }

    .custom-slider .vue-slider ul {
        background-color: #cbcbcb !important;
    }

    .custom-slider.vue-slider-component .vue-slider {
        background-color: #cbcbcb;
        height: 30px !important;
    }

    .custom-slider.vue-slider .vue-slider-process {
    }

    .custom-slider.vue-slider-horizontal .vue-slider-process {
        border-radius: 0 !important;
        background: linear-gradient(to right, #40ad2a, #2dbab8);
    }

    .custom-slider.vue-slider-component .vue-slider-process {
        position: relative;
        border-radius: 0 !important;
        background-color: #cbcbcb;
        cursor: pointer;
    }

    .custom-slider:after {
        content: "";
        position: absolute;
        top: 8px;
        left: -5px;
        border-top: 27px solid #fafafa;
        z-index: 1;
        border-right: 132px solid transparent
    }

    .custom-slider.vue-slider-component .vue-slider-tooltip {
        color: #333333;
        background-color: transparent;
        border: none;
    }

    .custom-slider.vue-slider-horizontal .vue-slider-dot {
        top: 0 !important;
        width: 14px !important;
        height: 29px !important;
        border-radius: 6.6px !important;
        background-color: #ffffff !important;
        border: solid 1px #aaaaaa;
    }

    .custom-slider.vue-slider-component .vue-slider-tooltip-wrap.vue-slider-tooltip-top {
        top: -4px;
    }

    @media screen and (max-width: 1199px){
        .custom-slider.vue-slider-component .vue-slider-process:after {
            border-right: 95px solid transparent;
        }
    }
</style>

<script>
import VueSlider from 'vue-slider-component'

export default {
  name: 'vacancy-voicebot-option-sliderRow',

  components: {
    VueSlider
  },

  props: {
    model: Object,
    selectedModel: Object,
    callback: { type: Function, default: _ => null }
  },

  methods: {},

  computed: {
    options () {
      return this.model.values.map(value => this.$tr(`vacancy.voiceBot.dialect.settings.${this.model.name}.sliderStatus.${value.id}`))
    },

    value: {
      get () {
        return this.selectedModel.values[0] ? this.selectedModel.values[0].name : null
      },

      set (val) {
        this.$store.commit('vacancy/voicebot/updateOption', {
          model: this.selectedModel,
          data: {
            values: [ { name: val, id: val } ]
          }
        })
      }
    }
  },

  beforeMount () {}
}
</script>
